module.exports = __webpack_public_path__ + "img/james-hardie-logo.3313b5cd.jpg";